enum CompanyFilterType {
  Active = "ACTIVE",
  ShowAll = "SHOW_ALL",
}

export default CompanyFilterType;
